module.exports = __webpack_public_path__ + "img/logo-wuhan.9f70a022.png";